import { Component, Inject, Optional, OnInit } from '@angular/core'; 
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import * as _ from 'lodash';
import * as peublos from "../../assets/data/pueblos.json";
import * as packages from "../../assets/data/packages.json";

@Component({
  selector: 'app-kw-estimate',
  templateUrl: './kw-estimate.component.html',
  styleUrls: ['./kw-estimate.component.css']
})
export class KwEstimateComponent implements OnInit {
	climateData = peublos.default;
	packages: any = packages.default;
	selectedPueblo: any;
	dailyAverage: number;
	capacityRequired: number;
	selectedPackage: string;
	capacityReal: number;
	kws: any;

	constructor(
		public dialogRef: MatDialogRef<KwEstimateComponent>,
	    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
    ) {
      	this.selectedPueblo = data.pueblo;
      	this.selectedPackage = data.package;
      	this.kws = data.kws;
    }

	ngOnInit(): void {
		this.updateCalcs()
	}

	updateCalcs(): void {
		this.dailyAverage = this.calculateDailyAverage();
		this.capacityRequired = this.calculateCapacityRequired(this.dailyAverage, this.selectedPueblo);
		this.capacityReal = this.calculateCapacityReal(this.capacityRequired, this.selectedPackage);
	}

	calculateDailyAverage() {
		var sum = _.sumBy(this.kws, 'kws');
		var average = sum/12;
		return average;
	}

	calculateCapacityRequired(average: number, pueblo: string) {
		var dailyAverage = _.chain(this.climateData)
												.find({ name: pueblo })
												.get('climate.average')
												.value();
		var capacity = average/dailyAverage/0.8;
		return capacity;
	}

	calculateCapacityReal(capacity: number, selectedPackage: any) {
		var wattage = selectedPackage.wattage;
		return Math.ceil(capacity/wattage*1000)*wattage/1000;
	}

	closeDialog(cancel: boolean = false){ 
		if (!cancel) {
			var data = {
				dailyAverage: this.dailyAverage,
				capacityRequired: this.capacityRequired,
				capacityReal: this.capacityReal,
				kws: this.kws,
				package: this.selectedPackage,
			}
	    this.dialogRef.close({event:'close', data: data});
	  } else {
	  	this.dialogRef.close({event:'close', data: {}});
	  }
  	}
}
